import TabRow, {Tab} from './TabRow'

export {TabRow, Tab}
export default TabRow
